import { OfferImpact } from "./CaseModel";

/**
 * A party's scalar net-result EV, read off the per-offer distribution stats:
 * the no-settlement (baseline) world and the settled world. Single source of
 * truth now that the old `OfferImpact.netResult` scalar has been removed.
 *
 * The `?? 0` is only a safety net — the afterFind migration auto-recomputes any
 * legacy impact that lacks these stats on read, so in practice they're present.
 */
export const baselineNet = (impact: OfferImpact): number =>
  impact.baselineStats?.netResult.average ?? 0;
export const settledNet = (impact: OfferImpact): number =>
  impact.settledStats?.netResult.average ?? 0;
